import { render } from "./JobBoard.vue?vue&type=template&id=621c0494&ts=true"
import script from "./JobBoard.vue?vue&type=script&lang=ts"
export * from "./JobBoard.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__